'use client';
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from '@/app/i18n/client';
import languageContext from '@/context/language';
import { Tabs } from '@/shared/components';
import { Certificates } from './certificates';
import { DataSheets } from './data-sheets';
import { usePageTracking } from '@/shared/tracking/use-tracking';
import { useSearchParams } from 'next/navigation';
import { useCountry } from '@/hooks/use-country';
import { BaseNumber } from './base-number';

export default function DocumentSearch() {
  usePageTracking();
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'document-search');
  const { isCN } = useCountry();
  const [defaultIndex, setDefaultIndex] = useState(0);
  const params = useSearchParams();
  useEffect(() => {
    const displayParam = params.get('display');
    if (!displayParam) return;
    if (displayParam === 'coa') {
      setDefaultIndex(0);
    } else if (displayParam === 'sds') {
      setDefaultIndex(1);
    }
  }, []);
  const tabData = [
    { title: t('Certificate'), content: <Certificates /> },
    { title: t('SDS'), content: <DataSheets /> },
  ];
  if (isCN) {
    tabData.push({ title: t('retest'), content: <BaseNumber /> });
  }
  return (
    <div className="grid grid-cols-[1fr_345px] w-full">
      <div className="col-span-2 mt-8 w-full mb-5">
        {isCN && <h1 className="font-medium">{t('title')}</h1>}
        {!isCN && <h1 className="font-medium">{t('title_kr')}</h1>}
      </div>
      <div className="col-span-2 grid">
        <Tabs tabContent={tabData} defaultIndex={defaultIndex} />
      </div>
    </div>
  );
}
